import {ActionReducer, Action, ActionReducerMap} from '@ngrx/store';
import * as actions from '../actions';
import {Events, FilterParams} from '../../models/events';


export interface EventsState {
  isLoading: boolean;
  isLoaded: boolean;
  entities: Events[];
}

export const initialState: EventsState = {
  isLoading: false,
  isLoaded: false,
  entities: []
};

export function reducer(state = initialState, action: actions.EventsActions): EventsState {
  switch (action.type) {
    case actions.EventsTypes.GET_EVENTS:
      return {...state, isLoading: true, isLoaded: false, entities: state.entities};
    case actions.EventsTypes.GET_EVENTS_SUCCESS:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload};
    case actions.EventsTypes.GET_EVENTS_FAIL:
      return {...state, isLoading: false, isLoaded: true, entities: []};
    default:
      return state;
  }
}

export function eventParams(state: FilterParams = {deviceName: '', status: -1, sn: ''},
                            action: actions.EventsActions): FilterParams {
  switch (action.type) {
    case actions.EventsTypes.GET_EVENTS_FILTER_PARAMS:
      return {...state,
        deviceName: action.payload.deviceName, status: action.payload.status,
        sn: action.payload.sn, filterId: action.payload.filterId, type: action.payload.type};
    default:
      return state;
  }
}
//
// export const getEvents = (state: EventsState) => state.entities;
// export const getEventsFilterParams = (state: FilterParams) => state;
